import { Outlet } from "react-router-dom";

const Servicios = () => {
  return (
    <div style={{ marginTop: "70px" }}>
      <Outlet />
    </div>
  );
};

export default Servicios;
